import type {State} from 'src/reducers';


export const selectTabErrors = (state: State): Set<string> => state.errors.tabs;
